import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../../util/varios";

import { Dimmer } from '../../spinner';
import {


  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@mui/material";
import useTableFijo from "../../useTableFijo";
import moment from "moment";
import { Mensaje, MensajeSiNo } from "../../mensajes";

const headCells = [
  {
    id: "",
    label: "AÑOS",
    width: "30px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "",
    label: "MES",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "",
    label: "MONTO",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "",
    label: "INTERES MORA",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "",
    label: "RECARGO",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "",
    label: "DESCUENTO",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "",
    label: "N° RECIBO",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "FECHA DE PAGO",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

const TablaHistoricosEjidos = (props) => {
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [contar, setContar] = useState(0);
  const [contar3, setContar3] = useState(0);
  const [activate, setActivate] = useState(false);
  const [idAgente, setIdAgente] = useState();
  const [periodo, setPeriodo] = useState();
  let op = require("../../../../src/modulos/datos");

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, 320);

  const [url, setUrl] = useState("");

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              ("R" || x.idfactura).includes(target.value) ||
              moment.utc(x.fechaenterami)
                .format("DD/MM/YYYY")
                .includes(target.value) ||
              x.periodo.toLowerCase().includes(target.value.toLowerCase()) ||
              x.numrete
                .toString()
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              formatMoneda(
                x.montorete.toString().replace(".", ","),
                ",",
                ".",
                2
              ).includes(target.value) ||
              x.descristatus.includes(target.value)
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const imprimirHistorico = (reporte) => (event) => {
    event.preventDefault();

    var idrentas = props.idrentas;
    reporte = "HisPago_RentaInmobiliaria";
    window.open(
      op.reportes + "/rentasinmobiliarias?" + "reporte=" + reporte + "&id=" + idrentas,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  useEffect(() => {
    if (props.tabHis) {
      setRecords(props.tabHis);
    }
  }, [props.tabHis]);

  const handleCloseNo = () => {
    setMostrar3(false);
  };

  const handleCloseSi = () => {
    setContar(0);
    setMostrar3(false);
    setActivate(true);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  return (
    <div className="card">
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />

      {/*< MensajeSiNo titulo={titulo} mensaje={msg}
                show={mostrar3}
                onHideSi={handleCloseSi} onHideNo={handleCloseNo} />*/}
      
<Dimmer active={activate} inverted>
      </Dimmer>

      <div className="card-body">
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12 d-flex justify-content-end py-2">
                <button
                title="Imprimir Historico de Pago"
                  onClick={imprimirHistorico("HisPago_RentaInmobiliaria")}
                  className="btn btn-sm btn-primary rounded-circle"
                >
                  <i className="fas fa-print"></i>
                </button>
              </div>

              <div className="col-md-12" style={{ margin: "auto" }}>
              <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                  <TblHead />

                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr
                          key={item.anio + item.mes}
                          style={{ padding: "0" }}
                        >
                          <td
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.anio}
                          </td>
                          <td
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.mes}
                          </td>
                          <td
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </td>
                          <td
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.intereses.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </td>
                          <td
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.recargo.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </td>
                          <td
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.descuento.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </td>
                          <td
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.recibo === null ? "" : item.recibo.trim()}
                          </td>
                          <td
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {moment.utc(item.fechapago).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </div>
              <div align="center" className="col-md-12">
                <a> &nbsp; </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaHistoricosEjidos;
